const wishlistAuthPanel = document.getElementById("wishlist-auth-panel");
const wishlistAuthBackdrop = document.querySelector(".wishlist-auth__backdrop");
let activeWishlistTrigger = null;
let wishlistAuthSubmitted = false;

const setWishlistAuthPanel = (open, panelName = "login", trigger = null) => {
    if(!wishlistAuthPanel || !wishlistAuthBackdrop) return;

    const previousTrigger = activeWishlistTrigger;
    if (open) wishlistAuthSubmitted = false;
    if (!open && previousTrigger?.dataset.productId && !wishlistAuthSubmitted) {
        try {
            sessionStorage.removeItem(pendingFavouriteKey);
            sessionStorage.removeItem(favouriteContextKey);
        } catch (error) { /* Storage can be unavailable. */ }
    }
    activeWishlistTrigger = open ? trigger : null;
    const quickAdd = document.querySelector('.product-quick-add--open');
    if (quickAdd) quickAdd.inert = open;
    if (!open && previousTrigger) previousTrigger.focus({ preventScroll: true });
    wishlistAuthPanel.classList.toggle("is-open", open);
    wishlistAuthBackdrop.classList.toggle("is-open", open);
    wishlistAuthPanel.setAttribute("aria-hidden", open ? "false" : "true");
    document.body.classList.toggle("wishlist-auth-open", open);
    window.KabookiSyncMobileLayerLock?.();

    if(open) {
        setWishlistAuthTab(panelName);
        document.dispatchEvent(new CustomEvent("kabooki:mobile-layer-open", {
            detail: { layer: "wishlist-auth", preserveQuickAdd: Boolean(trigger?.closest(".product-quick-add")) }
        }));
        window.setTimeout(() => {
            wishlistAuthPanel.querySelector(`[data-auth-panel-content="${panelName}"] input`)?.focus();
        }, 240);
    }
};

const setWishlistAuthTab = (panelName) => {
    if(!wishlistAuthPanel) return;

    wishlistAuthPanel.querySelectorAll(".js-wishlist-auth-tab").forEach((tab) => {
        const active = tab.dataset.authPanel === panelName;
        tab.classList.toggle("is-active", active);
        tab.setAttribute("aria-selected", active ? "true" : "false");
    });

    wishlistAuthPanel.querySelectorAll("[data-auth-panel-content]").forEach((panel) => {
        const active = panel.dataset.authPanelContent === panelName;
        panel.classList.toggle("is-active", active);
        panel.hidden = !active;
    });
};

document.addEventListener("click", (event) => {
    const trigger = event.target.closest(".js-wishlist-auth-trigger");
    if(!trigger || !wishlistAuthPanel) return;

    event.preventDefault();
    rememberFavouriteIntent(trigger);
    setWishlistAuthPanel(true, "login", trigger);
});

wishlistAuthPanel?.addEventListener("submit", () => { wishlistAuthSubmitted = true; });

document.querySelectorAll(".js-wishlist-auth-close").forEach((button) => {
    button.addEventListener("click", () => setWishlistAuthPanel(false));
});

wishlistAuthPanel?.querySelectorAll(".js-wishlist-auth-tab").forEach((tab) => {
    tab.addEventListener("click", () => setWishlistAuthTab(tab.dataset.authPanel));
});

document.addEventListener("kabooki:mobile-layer-open", (event) => {
    if(event.detail?.layer !== "wishlist-auth") setWishlistAuthPanel(false);
});

document.addEventListener("keydown", (event) => {
    if (!wishlistAuthPanel?.classList.contains("is-open")) return;
    if (event.key === "Tab") {
        const focusable = Array.from(wishlistAuthPanel.querySelectorAll('button, input, a[href]'))
            .filter(element => !element.disabled && element.getClientRects().length);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first?.focus();
        }
    }
    if(event.key === "Escape") {
        event.stopImmediatePropagation();
        event.preventDefault();
        setWishlistAuthPanel(false);
    }
}, true);

// Transfer the existing favourite intent without treating the handover as dismissal.
document.addEventListener('kabooki:gamification:takeover', () => {
    wishlistAuthSubmitted = true;
    setWishlistAuthPanel(false);
});
document.addEventListener('kabooki:gamification:registered', async () => {
    try {
        const productId = sessionStorage.getItem(pendingFavouriteKey);
        if (!productId) return;
        const response = await fetch('/user-wishlists', {credentials:'same-origin',cache:'no-store'});
        if (!response.ok) return;
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const marker = page.getElementById('js-primary-wishlist');
        const wishlistId = marker?.dataset.wishlistId;
        if (!wishlistId) return; // Preserve intent for the normal authenticated-page resume.
        const existing = (marker.dataset.wishlistProductMap || '').split('|').some(entry => entry.split(':')[0] === productId);
        if (!existing) await submitFavourite(productId, wishlistId);
        sessionStorage.removeItem(pendingFavouriteKey);
        sessionStorage.removeItem(favouriteContextKey);
    } catch (error) { console.error('Unable to resume favourite after game signup', error); }
});

const pendingFavouriteKey = "kabooki-pending-favourite-product";
const favouriteContextKey = "kabooki-favourite-return";

const rememberFavouriteIntent = (trigger) => {
    const productId = trigger.dataset.productId;
    if (!productId) return;
    const drawer = trigger.closest('.product-quick-add');
    try {
        sessionStorage.setItem(pendingFavouriteKey, productId);
        sessionStorage.setItem(favouriteContextKey, JSON.stringify({
            productId,
            returnUrl: window.location.href,
            productUrl: drawer?.dataset.productUrl || '',
            scrollY: window.scrollY,
            drawerScroll: (drawer?.querySelector('.sg-quick-scroll') || drawer?.querySelector('.product-quick-add__scroll'))?.scrollTop || 0,
            createdAt: Date.now()
        }));
    } catch (error) {
        // Login still works if browser storage is unavailable.
    }
};

const getPrimaryWishlistId = (trigger = null) => (
    trigger?.dataset.wishlistId ||
    document.getElementById("js-primary-wishlist")?.dataset.wishlistId ||
    document.querySelector(".js-primary-favourites")?.dataset.wishlistId ||
    ""
);

const updatePrimaryWishlistMarker = (nextMarker) => {
    const currentMarker = document.getElementById("js-primary-wishlist");
    if(!currentMarker || !nextMarker) return;
    currentMarker.dataset.wishlistProductMap = nextMarker.dataset.wishlistProductMap || "";
};

const setStaticFavouriteButton = (button, productId, wishlistProductId, wishlistId) => {
    if(!button || !wishlistProductId) return;
    button.classList.remove("js-add-to-wishlist");
    button.classList.add("js-remove-from-wishlist");
    button.dataset.id = wishlistProductId;
    button.dataset.productId = productId;
    button.dataset.wishlistId = wishlistId;
    button.setAttribute("aria-label", "Remove from favourites");
    button.querySelector(".wishlist-heart")?.classList.add("wishlist-heart--filled");
};

const submitFavourite = (productId, wishlistId) => {
    if(!productId || !wishlistId) throw new Error("Missing favourite details");

    const formData = new FormData();
    formData.append("product_id", productId);
    formData.append("wishlist_id", wishlistId);

    return fetch(window.location.href, {
        method: "POST",
        credentials: "same-origin",
        body: formData
    }).then((response) => {
        if(!response.ok) throw new Error("Unable to add favourite");
        return response.text();
    }).then((markup) => {
        const page = new DOMParser().parseFromString(markup, "text/html");
        const nextMarker = page.getElementById("js-primary-wishlist");
        const nextEntries = new Map(
            (nextMarker?.dataset.wishlistProductMap || "")
                .split("|")
                .map((value) => value.trim())
                .filter(Boolean)
                .map((value) => value.split(":"))
        );
        const wishlistProductId = nextEntries.get(String(productId)) || "";
        if(!wishlistProductId) throw new Error("Favourite was not returned by the shop");

        updatePrimaryWishlistMarker(nextMarker);
        document.dispatchEvent(new CustomEvent("kabooki:favourites-updated", {
            detail: { productId: String(productId), wishlistProductId, wishlistId, favourite: true }
        }));
        return { wishlistProductId, wishlistId };
    });
};

function addToWishList(id, trigger = null, wishlistId = "") {
    return submitFavourite(id, wishlistId || getPrimaryWishlistId(trigger));
}

document.addEventListener("click", (event) => {
    const button = event.target.closest(".js-add-to-wishlist");
    if(!button) return;

    event.preventDefault();
    button.disabled = true;
    const productId = button.getAttribute("data-product-id") || button.getAttribute("data-id");

    addToWishList(productId, button).then((result) => {
        setStaticFavouriteButton(button, productId, result.wishlistProductId, result.wishlistId);
    }).catch((error) => {
        console.error(error);
    }).then(() => {
        button.disabled = false;
    });
});

document.addEventListener("click", (event) => {
    const trigger = event.target.closest(".js-create-first-wishlist");
    if(!trigger) return;

    rememberFavouriteIntent(trigger);
});

const defaultWishlistForm = document.querySelector(".js-create-default-wishlist");
if(defaultWishlistForm) {
    defaultWishlistForm.submit();
}

// Resume only after the shop has returned an authenticated wishlist marker.
try {
    const productId = sessionStorage.getItem(pendingFavouriteKey);
    const wishlistId = getPrimaryWishlistId();
    const context = JSON.parse(sessionStorage.getItem(favouriteContextKey) || 'null');
    const expired = context && Date.now() - context.createdAt > 30 * 60 * 1000;
    if (expired) {
        sessionStorage.removeItem(pendingFavouriteKey);
        sessionStorage.removeItem(favouriteContextKey);
    } else if (productId && wishlistId) {
        const existing = (document.getElementById('js-primary-wishlist')?.dataset.wishlistProductMap || '')
            .split('|').some(entry => entry.split(':')[0] === productId);
        const saved = existing ? Promise.resolve() : submitFavourite(productId, wishlistId);
        saved.then(() => {
            sessionStorage.removeItem(pendingFavouriteKey);
            if (context?.productId === productId) {
                const returnUrl = new URL(context.returnUrl, window.location.origin);
                if (returnUrl.origin === window.location.origin) {
                    sessionStorage.setItem(favouriteContextKey, JSON.stringify({ ...context, ready: true }));
                    window.location.replace(returnUrl.href);
                }
            }
        }).catch(error => console.error('Unable to resume favourite', error));
    }
} catch(error) {
    // The favourites page remains usable when storage is unavailable.
}

function removeFromWishList(id) {
    if (window.KabookiFavouriteRemoval?.enabled()) return window.KabookiFavouriteRemoval.remove(id);
    const formData = new FormData();
    formData.append(`wishlist_product[${id}][remove]`, '1');
    return fetch(window.location.href, {
        method: 'POST',
        body: formData
    });
}

document.addEventListener("click", (event) => {
    const button = event.target.closest(".js-remove-from-wishlist");
    if(!button) return;

    event.preventDefault();
    button.disabled = true;

    removeFromWishList(button.getAttribute("data-id")).then((response) => {
        if(!response.ok) throw new Error("Unable to remove favourite");

        const favouriteCard = button.closest(".favourites-products__item");
        if(favouriteCard) {
            const favouritesGrid = favouriteCard.parentElement;
            favouriteCard.remove();
            if(favouritesGrid && !favouritesGrid.querySelector(".favourites-products__item")) {
                const emptyMessage = document.createElement("p");
                emptyMessage.className = "favourites-products__empty";
                emptyMessage.textContent = "You have not saved any favourites yet.";
                favouritesGrid.append(emptyMessage);
            }
            return true;
        }

        button.classList.remove("js-remove-from-wishlist");
        button.classList.add("js-add-to-wishlist");
        button.dataset.id = button.dataset.productId;
        button.setAttribute("aria-label", "Add to favourites");
        button.querySelector(".wishlist-heart")?.classList.remove("wishlist-heart--filled");
        button.disabled = false;
        return false;
    }).catch(() => {
        button.disabled = false;
    });
});


// Keep registration, including Shoporama's captcha, inside the current dialog.
const wishlistSignup = wishlistAuthPanel?.querySelector('[data-auth-panel-content="signup"]');
const wishlistSignupForm = wishlistSignup?.querySelector('form');
const wishlistCaptcha = wishlistSignup?.querySelector('.wishlist-auth__captcha');
const wishlistSignupError = wishlistSignup?.querySelector('.wishlist-auth__signup-error');
const wishlistSignupSuccess = wishlistSignup?.querySelector('.wishlist-auth__signup-success');
let wishlistSignupBusy = false;
let wishlistSignupTrackingAttempt = null;

const submitWishlistSignup = async (form, submitter) => {
    if (wishlistSignupBusy) return;
    if (form === wishlistSignupForm) wishlistSignupTrackingAttempt = window.KabookiClubTracking?.begin('wishlist');
    wishlistSignupBusy = true;
    wishlistAuthSubmitted = true;
    const buttons = Array.from(wishlistSignup.querySelectorAll('button'));
    const payload = new FormData(form);
    if (submitter?.name && !payload.has(submitter.name)) payload.append(submitter.name, submitter.value);
    buttons.forEach(button => { button.disabled = true; });
    wishlistSignup.setAttribute('aria-busy', 'true');
    wishlistSignupError.hidden = true;
    try {
        const response = await fetch(form.action, {
            method: 'POST', credentials: 'same-origin', cache: 'no-store', body: payload,
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!response.ok) throw new Error(wishlistAuthPanel.dataset.signupError);
        if (page.querySelector('.user-area__created')) {
            const continueToThanks = () => window.location.assign('/club-thank-you');
            if (wishlistSignupTrackingAttempt) wishlistSignupTrackingAttempt.confirm(response, page, continueToThanks);
            else continueToThanks();
            wishlistSignupForm.hidden = true;
            wishlistCaptcha.hidden = true;
            wishlistSignup.querySelector('.wishlist-auth__signup-intro').hidden = true;
            wishlistSignupSuccess.hidden = false;
            wishlistSignupSuccess.focus();
        } else if (page.querySelector('form.captcha')) {
            const captcha = document.importNode(page.querySelector('form.captcha'), true);
            const action = new URL(response.url || form.action, location.href);
            if (action.origin !== location.origin) throw new Error(wishlistAuthPanel.dataset.signupError);
            captcha.action = action.href;
            captcha.querySelectorAll('[onclick]').forEach(element => element.removeAttribute('onclick'));
            captcha.querySelectorAll('script').forEach(element => element.remove());
            const heading = captcha.querySelector('h1');
            if (heading) {
                const replacement = document.createElement('h3');
                replacement.textContent = heading.textContent;
                heading.replaceWith(replacement);
            }
            const image = captcha.querySelector('img');
            if (image) {
                image.src = new URL(image.getAttribute('src'), action).href;
                image.alt = wishlistAuthPanel.dataset.captchaImageAlt || 'Robot verification code';
            }
            const input = captcha.querySelector('input[name="c"]');
            input?.setAttribute('aria-label', input.placeholder || wishlistAuthPanel.dataset.captchaImageAlt);
            const refresh = captcha.querySelectorAll('button')[1];
            if (refresh) {
                refresh.type = 'button';
                refresh.classList.add('js-wishlist-captcha-refresh');
            }
            wishlistCaptcha.replaceChildren(captcha);
            wishlistSignupForm.hidden = true;
            wishlistCaptcha.hidden = false;
            input?.focus();
        } else {
            throw new Error(page.querySelector('.alert--error, .notification--error, .input-wrapper--error .error, [role="alert"]')?.textContent.trim() || wishlistAuthPanel.dataset.signupError);
        }
    } catch (error) {
        wishlistSignupError.textContent = error.message || wishlistAuthPanel.dataset.signupError;
        wishlistSignupError.hidden = false;
        wishlistSignupError.focus();
    } finally {
        wishlistSignupBusy = false;
        buttons.forEach(button => { button.disabled = false; });
        wishlistSignup.setAttribute('aria-busy', 'false');
    }
};

wishlistSignup?.addEventListener('submit', event => {
    event.preventDefault();
    submitWishlistSignup(event.target, event.submitter);
});
wishlistSignup?.addEventListener('click', event => {
    if (event.target.closest('.js-wishlist-captcha-refresh')) {
        submitWishlistSignup(wishlistSignupForm, wishlistSignupForm.querySelector('[type="submit"]'));
    }
});
